var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GmapMap',{staticStyle:{"width":"100%","height":"300px"},attrs:{"id":"map","center":_vm.playerPosition,"zoom":16,"options":{
    minZoom: 18,
    maxZoom: 20,
    zoomControl: false,
    streetViewControl: false,
    clickableIcons: false,
    styles: [
      {
        featureType: 'poi',
        stylers: [{ visibility: 'off' }]
      }
    ]
  },"map-type-id":"roadmap"}},[_c('GmapCircle',{attrs:{"center":_vm.playerPosition,"radius":10,"options":{
      strokeColor: '#03b2ff',
      strokeOpacity: 0.5,
      fillOpacity: 0.2
    }}}),_c('GmapCircle',{attrs:{"center":_vm.playerPosition,"radius":2,"options":{
      strokeOpacity: 0,
      fillColor: '#03b2ff',
      fillOpacity: 0.9
    }}}),_vm._l((_vm.locations),function(location,index){return _c('GmapMarker',{key:index,attrs:{"position":{ lat: location.lat, lng: location.lon },"title":location.name,"clickable":""},on:{"click":function($event){return _vm.selectLocation(location)}}})}),_c('v-dialog',{attrs:{"width":"500"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-text',{staticClass:"mx-auto"},[_c('location-card-text',_vm._b({},'location-card-text',_vm.selectedLocation,false))],1),_c('v-divider'),_c('v-card-actions',[_c('v-btn',{attrs:{"disabled":!_vm.enableVisitButton},on:{"click":function($event){return _vm.visit()}}},[_vm._v("Visit")]),_c('div',{staticClass:"flex-grow-1"}),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v("OK")])],1)],1)],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }